export default __webpack_public_path__ + "static/media/P40003.dd015856.png";